import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { reduxForm, Field, reset, change, untouch } from 'redux-form';
import {
  InputFieldComponent,
  SelectFieldComponent,
} from '../../atoms/atoms.index';
import { required, maxLength20 } from '../../../utils/FormValidators';
import { useDispatch, useSelector } from 'react-redux';
import { EInput } from '../../../domain/input.interface';
import { makeSelectWishListCatalogue } from '../../../store/wishlist/wishlist.selectors';
import { EFormName } from '../../../config/form-names.config';
import { EWishlistVisibility } from '../../../domain/wish.interface';

function NewWishListModalFormComponent(props: any) {
  const { showModal, handleClose, handleSubmit, submitForm } = props;
  const dispatch = useDispatch();
  const wishListCatalogue = useSelector(makeSelectWishListCatalogue());
  const [copyList, setCopyList] = useState(false);
  const [wishlistVisibility, setWishlistVisibility] = useState(
    EWishlistVisibility.PRIVATE,
  );

  function resetModal() {
    handleClose();
    setCopyList(false);
    dispatch(reset(EFormName.NEW_WISH_LIST));
  }

  useEffect(() => {
    if (!copyList) {
      dispatch(change(EFormName.NEW_WISH_LIST, 'copyWishListId', null));
      dispatch(untouch(EFormName.NEW_WISH_LIST, 'copyWishListId'));
    }
    // eslint-disable-next-line
  }, [copyList]);

  return (
    <Modal show={showModal} onHide={() => resetModal()} size='xl' centered>
      <Modal.Header className='pb-0' closeButton>
        <Modal.Title>
          <FormattedMessage id='organisms.new-wish-list-modal-form.title' />
        </Modal.Title>
      </Modal.Header>
      <form
        className='new-list-form'
        name={EFormName.NEW_WISH_LIST}
        onSubmit={handleSubmit((values: any) => {
          setCopyList(false);
          submitForm({...values, visibility: wishlistVisibility});
        })}
      >
        <Modal.Body>
          <div className='form-field-container mb-3'>
            <FormattedMessage id='organisms.new-wish-list-modal-form.list_name'>
              {txt => (
                <Field
                  name={'name'}
                  type={EInput.TEXT}
                  component={InputFieldComponent}
                  label={txt}
                  validate={[required, maxLength20]}
                />
              )}
            </FormattedMessage>
          </div>
          <div className='field-container mb-5'>
            <div className='radio-container'>
              <label htmlFor='visibility-private' className='radio'>
                <input
                  name='visibility-type-radio'
                  onChange={() =>
                    setWishlistVisibility(EWishlistVisibility.PRIVATE)
                  }
                  value={EWishlistVisibility.PRIVATE}
                  type='radio'
                  id='visibility-private'
                  className='hide'
                  checked={wishlistVisibility === EWishlistVisibility.PRIVATE}
                />
                <span className='label'></span>
                <p className='input-label'>
                  <span className='main'>
                    <FormattedMessage id='common.private' />
                  </span>
                </p>
              </label>
              <label htmlFor='visibility-public' className='radio'>
                <input
                  name='visibility-type-radio'
                  onChange={() =>
                    setWishlistVisibility(EWishlistVisibility.PUBLIC)
                  }
                  value={EWishlistVisibility.PUBLIC}
                  type='radio'
                  id='visibility-public'
                  className='hide'
                  checked={wishlistVisibility === EWishlistVisibility.PUBLIC}
                />
                <span className='label'></span>
                <p className='input-label'>
                  <span className='main'>
                    <FormattedMessage id='common.public' />
                  </span>
                </p>
              </label>
            </div>
          </div>
          <div className='field-container'>
            <label htmlFor={props.name} className='checkbox'>
              <input
                type={EInput.CHECKBOX}
                onChange={() => setCopyList(!copyList)}
              />
              <span className='checkmark'></span>
              <span>
                <FormattedMessage id='organisms.new-wish-list-modal-form.copy_list' />
              </span>
            </label>
          </div>
          <div
            className={`form-field-container mt-3 ${
              copyList ? 'shown' : 'hidden'
            }`}
          >
            <FormattedMessage id='organisms.new-wish-list-modal-form.select_list'>
              {txt => (
                <Field
                  name={'copyWishListId'}
                  type={EInput.SELECT}
                  component={SelectFieldComponent}
                  label={txt}
                  propsOptions={wishListCatalogue}
                  validate={copyList ? [required] : []}
                />
              )}
            </FormattedMessage>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className='btn-lili form-button danger mb-3 cancel-btn'
            type='button'
            onClick={() => resetModal()}
          >
            <FormattedMessage id='common.cancel'></FormattedMessage>
          </button>
          <button className='btn-lili form-button  mb-3' type='submit'>
            <FormattedMessage id='common.save'></FormattedMessage>
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default reduxForm({
  form: EFormName.NEW_WISH_LIST,
})(NewWishListModalFormComponent);
